var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 300 300",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 36 147 L 36 85 L 132 85 L 132 137 L 166 137 L 166 85 L 263 85 L 263 147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 102 138 L 197 138 L 197 201 L 102 201 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 197 147 L 263 147 L 278 173 L 197 173 Z",
    fill: "#0000ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 36 147 L 102 147 L 102 173 L 20 173 Z",
    fill: "#0000ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 102 201 L 197 201 L 213 225 L 85 225 Z",
    fill: "#0000ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 69 159 L 102 159"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 197 159 L 229 159"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 134 213 L 165 213"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 200,
    x: 3,
    y: 50,
    rx: 20,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 250 L 150 290"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 290 L 230 290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualDesktop);
export default __webpack_public_path__ + "static/media/virtual-desktop.f2907a65c5793f659c5e26cc9e444709.svg";
export { ForwardRef as ReactComponent };